import { AfterViewInit, Component } from '@angular/core';
import { DatepickerComponent } from "../../../utils/datepicker/datepicker.component";
import { ReportsServicesService } from '../../../services/reports-services.service';
import { jwtDecode } from 'jwt-decode';
import { CustomTableComponent } from '../../../utils/custom-table/custom-table.component';
import { CustomButton } from '../../../models/customButton';
import { LoaderComponent } from "../../../utils/loader/loader.component";
import { InvoiceStatus } from '../../../models/invoiceStatus';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../../theme.service';
import { environment } from '../../../../environments/environment';
import { Button, ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-account-statement',
    imports: [DatepickerComponent, CustomTableComponent, LoaderComponent,ButtonModule],
    templateUrl: './account-statement.component.html',
    styleUrl: './account-statement.component.scss'
})
export class AccountStatementComponent implements AfterViewInit {
  data: any;
  tokenAuth: any;
  fromDate!: Date;
  toDate!: Date;
  loading=true;
  reporterURL=environment.wrUrl;
  headers: any[] = [
    { key: "date", textHeader: "Emisión", visible: true, type: "date" },
    { key: "dueDate", textHeader: "Vencimiento", visible: true, type: "date" },
    { key: "serieFolio", textHeader: "Factura", visible: true, type: "string" },
    { key: "subtotal", textHeader: "SubTotal", visible: true, type: "currency" },
    { key: "total", textHeader: "Importe", visible: true, type: "currency" },
    { key: "balance", textHeader: "Saldo", visible: true, type: "currency" },
    { key: "paymentStatus", textHeader: "Estatus", visible: true, type: "string" },


  ];

  tblButtons:CustomButton[] = [
    {
      text: 'Consumos',
      action: (event: any) => this.generateReportConsumptions(event, "pdf"),
      icon: undefined,
      color: '',
      hasIcon: false,
      showText: true,
    },
    {
      text: 'Excel',
      action: (event: any) => this.generateReportConsumptions(event, 'excel'),
      icon: undefined,
      color: '',
      hasIcon: false,
      showText: true,
    },
    {
      text: 'Factura',
      action: (event: any) => this.generateInvoice(event, 'pdf'),
      icon: undefined,
      color: '',
      hasIcon: false,
      showText: true,
    },

    {
      text: 'XML',
      action: (event: any) => this.generateInvoice(event, 'xml'),
      icon: undefined,
      color: '',
      hasIcon: false,
      showText: true,
    },
    {
      text: 'Txt',
      action: (event: any) => this.generateReportConsumptions(event, 'txt'),
      icon: undefined,
      color: '',
      hasIcon: false,
      showText: true,
    },
  ]
  requestFrom: any;

  requestTo: any;

  invoices!: any[];
  constructor(private rptServices: ReportsServicesService, private titleService:Title,private themeService:ThemeService
    
  ) {
    this.themeService.setTitle("Estado de cuenta");
    this.titleService.setTitle("Estado de Cuenta")

    this.data = JSON.parse(localStorage.getItem('data')!); 
  }
  ngAfterViewInit(): void {
    this.getStatement();
  }

  ngOnInit() {
    let today = new Date();
    this.fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
    this.toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);

 
  }
  setDatesOnFilter(event: any) {

    this.fromDate = event.from;
    this.toDate = event.to;

  }

  getStatement() {
    this.loading=true;
    this.requestFrom = new Date(this.fromDate);
    this.requestTo = new Date(this.toDate);

    this.rptServices.getStataments(this.data.Client_id, this.requestFrom, this.requestTo).subscribe({
      next: (resp: any) => {
        this.loading=false;
        
        resp.forEach((element:any) => {
          
          element.paymentStatus= InvoiceStatus[element.paymentStatus];
        });
        this.invoices = resp;
      },
       error :(error: any) =>{
        this.loading=false;
        this.invoices=[]
       }
    })
  }

  generateReportConsumptions(invoice: any, type: string) {

   
   let url ='' 
   if(type=='pdf'){
    url = this.reporterURL+type+'/MonederoXiga.aspx?rptId=data&rptName=rpt_ConsumptionsByInvoice&invoice='+invoice.id+'&clientId='+this.data.Client_id+'&langId=2';
   }else if(type=='excel' ){
    url = this.reporterURL+type+'/MonederoXiga.aspx?rptName=statement&invoice='+invoice.id+'&clientId='+this.data.Client_id;
   }else{
    url = this.reporterURL+'pdf/MonederoXiga.aspx?rptId=txt&invoice='+invoice.id+'&clientId='+this.data.Client_id;
   }
  
  
   window.open(url, "_blank");
    
  }

  generateInvoice(invoice: any, type: string) {
    let url ='' 
    if(type=='pdf'){
     
     url = this.reporterURL+type+'/MonederoXiga.aspx?rptId=data&DataServer=NexusFEMonedero&langId=2&rptName=rpt_electronicPurseInvoiceSingle&invoiceId='+invoice.reference;
    }else{
      

     url = this.reporterURL+'pdf/MonederoXiga.aspx?rptId=xml&invoiceId='+invoice.reference;
    }
   
    window.open(url, "_blank");
  }

  getFile(data:any){
   
  }
}
